import AddRemoveFromGroupPlay from '../../../../../lessons/lessonactions/add-remove-from-group-play/AddRemoveFromGroupPlay';
import { useGroupPlay } from '../../context/GroupPlayContextProvider';
import Logger from '../../../../../../utils/Logger';
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  onSuccess: () => {},
};

export default function GroupPlayAddRemoveFromGroupPlay(p) {
  const {
    lesson,
    onSuccess,
  } = { ...defaultProps, ...filterUndefined({ ...p }) };
  const { groupPlayDomain } = useGroupPlay();
  const { lessonData } = groupPlayDomain.domainData;

  return (
    <AddRemoveFromGroupPlay
      lesson={lesson}
      onSaveSuccess={async (updatedLesson) => {
        Logger.logWhenDebugModeIsOn({
          UPDATED_LESSON: updatedLesson,
        });
        const { lessons } = lessonData;
        const updatedLessons = lessons.filter((l) => l.id !== lesson.id);

        const updatedLessonData = {
          ...lessonData,
          lessons: updatedLessons,
        };
        onSuccess();
        await groupPlayDomain.updateLessonGroupPlay(updatedLessonData);
      }}
    />
  );
}
